export default "__VITE_ASSET__CpScIOgz__"